module.exports = __webpack_public_path__ + "static/img/huajiao.7b0a42de.png";